import styled from 'styled-components'

const Table = styled.table`
  width: 100%;
  border: 1px solid black;
  border-spacing: 0;
  thead tr {
    background-color: #CCCCCC;
  }
  tbody tr:nth-child(odd) {
    background-color: #EEEEEE;
  }
  tbody td {
    padding: 0.25em;
  }
  tr td, tr th {
    border-right: 1px solid black;
    width: 100px;
    text-align: center;
  }
  tr td:first-child, tr th:first-child {
    width: 50%
    text-align: left;
  }
`

export default Table



// WEBPACK FOOTER //
// ./src/components/Table.js